// src/components/sections/ProfileSection.jsx
import InputForm from "../ui/InputForm";
import Button from "../ui/Button";
import Checkbox from "../ui/Checkbox";
import Divider from "../ui/Divider";

import "./ProfileSection.css";

const MAX_DESCRIPTION = 1000;
const ROLE_OPTIONS = [
  { value: "superadmin", label: "Superadmin" },
  { value: "admin", label: "Admin" },
  { value: "user", label: "User" },
];

function ProfileSection({
  profile,
  onChange,
  readOnly = false,
  roleOptions = ROLE_OPTIONS,
  locationOptions = { regions: [], gemeentes: [] },
  showPassword = false,
}) {
  const handleChange = (field) => (event) => {
    if (readOnly) return;
    const value = event?.target?.value ?? "";
    if (field === "function_description") {
      onChange(field, value.slice(0, MAX_DESCRIPTION));
      return;
    }
    if (field === "region" || field === "gemeente") {
      onChange(field, value ? Number(value) : null);
      return;
    }
    onChange(field, value);
  };

  const descriptionValue = profile?.function_description ?? "";

  const regionOptions = (locationOptions?.regions || []).map((r) => ({
    value: r.id,
    label: r.name,
  }));
  const gemeenteOptions = (locationOptions?.gemeentes || [])
    .filter((g) => {
      if (profile?.role === "admin" && profile?.region) {
        return g.region_id === Number(profile.region);
      }
      if (profile?.role === "superadmin" && profile?.region) {
        return g.region_id === Number(profile.region);
      }
      return true;
    })
    .map((g) => ({ value: g.id, label: g.name }));

  const showRegion = profile?.role === "admin" || profile?.role === "superadmin";
  const showGemeente = profile?.role === "user";
  const regionValue = profile?.region ? String(profile.region) : "";
  const gemeenteValue = profile?.gemeente ? String(profile.gemeente) : "";

  return (
    <section className="profile-section">

      <div className="profile-row">
        <div className="profile-row-left">
          <h4>Voornaam <span>*</span></h4>
        </div>
        <div className="profile-row-right">
          <InputForm
            icon="user-line.png"
            type="text"
            placeholder="Voornaam"
            value={profile?.first_name || ""}
            onChange={handleChange("first_name")}
            readOnly={readOnly}
            disabled={readOnly}
          />
        </div>
      </div>

      <Divider />

      <div className="profile-row">
        <div className="profile-row-left">
          <h4>E-mailadres <span>*</span></h4>
        </div>
        <div className="profile-row-right">
          {/* Emailadres */}
          <InputForm
            icon="mail-line.png"
            type="email"
            placeholder="you@example.com"
            value={profile?.email || ""}
            onChange={handleChange("email")}
            readOnly={readOnly}
            disabled={readOnly}
            leftIcon="/icons/mail-01.png"
          />
        </div>
      </div>

      <Divider />

      <div className="profile-row">
        <div className="profile-row-left">
          <h4>Rol<span>*</span></h4>
        </div>
        <div className="profile-row-right">
          {/* Rol */}
          <InputForm
            label=""
            icon="shield-user-line.png"
            type="select"
            placeholder="Kies rol"
            value={profile?.role || ""}
            onChange={handleChange("role")}
            options={roleOptions}
            leftIcon="/icons/user-01.png"
            disabled={readOnly}
          />
        </div>
      </div>

      {showRegion && (
        <div className="profile-row">
          <div className="profile-row-left">
            <h4>Regio<span>*</span></h4>
          </div>
          <div className="profile-row-right">
            <InputForm
            icon="map-pin-05.png"
            type="select"
            placeholder="Kies regio"
            value={regionValue}
            onChange={handleChange("region")}
            options={regionOptions}
            leftIcon="/icons/briefcase.png"
            disabled={readOnly}
          />
          </div>
        </div>
      )}

      {showGemeente && (
        <div className="profile-row">
          <div className="profile-row-left">
            <h4>Gemeente<span>*</span></h4>
          </div>
          <div className="profile-row-right">
            <InputForm
            icon="map-pin-05.png"
            type="select"
            placeholder="Kies gemeente"
            value={gemeenteValue}
            onChange={handleChange("gemeente")}
            options={gemeenteOptions}
            leftIcon="/icons/briefcase.png"
            disabled={readOnly}
          />
          </div>
        </div>
      )}

      {showPassword && (
        <div className="profile-row">
          <div className="profile-row-left">
            <h4>Wachtwoord {profile?.id ? "(optioneel)" : "(verplicht)"}<span>*</span></h4>
          </div>
          <div className="profile-row-right">
            <InputForm
              icon="lock-01.png"
              type="password"
              placeholder="Wachtwoord"
              value={profile?.password || ""}
              onChange={handleChange("password")}
              readOnly={readOnly}
              disabled={readOnly}
            />
          </div>
        </div>
      )}

      <div className="profile-row">
        <div className="profile-row-left">
          <h4>Jouw foto<span>*</span></h4>
            <p className="form-hint">
            Deze zal getoond worden als je bent ingelogd.
          </p>
        </div>
        <div className="profile-row-right">
          <div className="form-photo">
          <img
              src="/avatar-profile.png"
              alt="Avatar"
              className="avatar"
          />
          <Button variant="secondary" size="sm">
              Update
          </Button>
          <Button variant="danger" size="sm">
              Delete
          </Button>
      </div>
        </div>
      </div>

      <Divider />

            {/* Functie */}
            <div className="profile-row">
                <div className="profile-row-left">
                    <h4>Functie<span></span></h4>
                </div>
                <div className="profile-row-right">
                    {/* Uw organisatie */}
                    <InputForm
                        type="text"
                        placeholder="Wat is jou functie?"
                        value={profile?.function_title || ""}
                        onChange={handleChange("function_title")}
                        readOnly={readOnly}
                        disabled={readOnly}
                    />
                    <Checkbox
                        label="Laat mijn functiebeschrijving zien"
                        defaultChecked
                        disabled={readOnly}
                    />
                </div>
            </div>

            <Divider />

            <div className="profile-row">
                <div className="profile-row-left">
                    <h4>Functiebeschrijving<span></span></h4>
                    <p className="form-hint">
                       Schrijf een kort stukje over jezelf.
                    </p>
                </div>
                <div className="profile-row-right">
                    {/* Uw organisatie */}
                    <textarea
                        className="form-input profile-textarea"
                        placeholder="Wat is jou functie?"
                        value={descriptionValue}
                        onChange={handleChange("function_description")}
                        readOnly={readOnly}
                        disabled={readOnly}
                        maxLength={MAX_DESCRIPTION}
                    />
                    <span className="char-counter">
                        {MAX_DESCRIPTION - descriptionValue.length} tekens over
                    </span>
                </div>
            </div>
            <Divider />
        </section>
    );
}

export default ProfileSection;
